module.exports = __webpack_public_path__ + "img/gradient.88c5f688.png";